import * as $runtime from "../runtime.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dEnum from "../Data.Enum/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dUnfoldable1 from "../Data.Unfoldable1/index.js";
import * as Restaumatic$dPrelude$dSpecular from "../Restaumatic.Prelude.Specular/index.js";
import * as Specular$dDom$dBuilder from "../Specular.Dom.Builder/index.js";
import * as Specular$dDom$dElement from "../Specular.Dom.Element/index.js";
import * as Specular$dDom$dWidget from "../Specular.Dom.Widget/index.js";
import * as Specular$dExtra$dSwitch from "../Specular.Extra.Switch/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dFRP$dReplaceable from "../Specular.FRP.Replaceable/index.js";
import * as Specular$dInternal$dIncremental from "../Specular.Internal.Incremental/index.js";
import * as Specular$dInternal$dIncremental$dNode from "../Specular.Internal.Incremental.Node/index.js";
import * as Specular$dInternal$dRIO from "../Specular.Internal.RIO/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
const $Alert = _1 => ({tag: "Alert", _1});
const $AlertType = tag => ({tag});
const $ControlState = tag => ({tag});
const $DownloadButtonOptions = _1 => ({tag: "DownloadButtonOptions", _1});
const monadFRP = {MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO, MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder};
const dynamic_ = /* #__PURE__ */ Specular$dFRP$dReplaceable.dynamic_(Specular$dDom$dBuilder.monadReplaceBuilder)(monadFRP);
const traverse_ = /* #__PURE__ */ Data$dFoldable.traverse_(Specular$dInternal$dRIO.applicativeRIO)(Data$dFoldable.foldableArray);
const dynamicSwitch = /* #__PURE__ */ Specular$dExtra$dSwitch.dynamicSwitch(Specular$dExtra$dSwitch.switchEvent)(Specular$dDom$dBuilder.monadReplaceBuilder)(monadFRP);
const Enabled = /* #__PURE__ */ $ControlState("Enabled");
const Disabled = /* #__PURE__ */ $ControlState("Disabled");
const DownloadButtonOptions = value0 => $DownloadButtonOptions(value0);
const Info = /* #__PURE__ */ $AlertType("Info");
const $$Error = /* #__PURE__ */ $AlertType("Error");
const Success = /* #__PURE__ */ $AlertType("Success");
const Warning = /* #__PURE__ */ $AlertType("Warning");
const Alert = value0 => $Alert(value0);
const testIdLegacyAdapterProp = {testId: /* #__PURE__ */ Specular$dDom$dElement.attr("data-testid")};
const testIdLegacyAdapterAttrs = {
  testId: x => {
    const $0 = {};
    $0["data-testid"] = x;
    return $0;
  }
};
const whitespace = /* #__PURE__ */ Specular$dDom$dElement.text(" ");
const visibleIfDyn = dynCond => inner => dynamic_(Specular$dFRP$dBase.functorDynamic.map(v => {
  if (v) { return inner; }
  return Restaumatic$dPrelude$dSpecular.wempty;
})(dynCond));
const toControlStateAttr = v => {
  if (v.tag === "Disabled") { return Specular$dDom$dElement.attr("disabled")("true"); }
  return Specular$dDom$dElement.monoidProp.mempty;
};
const testId = dict => dict.testId;
const specularToDomNode = Unsafe$dCoerce.unsafeCoerce;
const primaryButton = /* #__PURE__ */ Specular$dDom$dElement.class_("btn btn-primary");
const mkAlert = alertType => message => $Alert({alertType, message});
const successAlert = /* #__PURE__ */ mkAlert(Success);
const warningAlert = /* #__PURE__ */ mkAlert(Warning);
const labeledForm = txt => control => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("label")([Specular$dDom$dElement.class_("control-label")])(Specular$dDom$dElement.text(txt)))(() => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el_("br")(Restaumatic$dPrelude$dSpecular.wempty))(() => control));
const itemToIndex = dictEnum => dictBounded => {
  const elemIndex = Data$dArray.elemIndex(dictBounded.Ord0().Eq0());
  const bottom = dictBounded.bottom;
  const top = dictBounded.top;
  return dictBoundedEnum => {
    const allEnumValues1 = Data$dEnum.enumFromTo(dictBoundedEnum.Enum1())(Data$dUnfoldable1.unfoldable1Array)(bottom)(top);
    return item => {
      const $0 = elemIndex(item)(allEnumValues1);
      if ($0.tag === "Just") { return $0._1; }
      $runtime.fail();
    };
  };
};
const infoAlert = /* #__PURE__ */ mkAlert(Info);
const fileDownloadButton = v => {
  const $0 = v._1;
  return Specular$dDom$dElement.el("form")([Specular$dDom$dElement.attr("action")($0.url), Specular$dDom$dElement.attr("method")("get")])(Specular$dInternal$dRIO.bindImpl(traverse_(v1 => Specular$dDom$dElement.el("input")([
    Specular$dDom$dElement.attr("type")("hidden"),
    Specular$dDom$dElement.attr("name")(v1._1),
    Specular$dDom$dElement.attr("value")(v1._2)
  ])(Restaumatic$dPrelude$dSpecular.wempty))($0.params))(() => Specular$dDom$dElement.el("button")([
    Specular$dDom$dElement.attr("type")("submit"),
    $0.state.tag === "Disabled" ? Specular$dDom$dElement.attr("disabled")("true") : Specular$dDom$dElement.monoidProp.mempty
  ])(Specular$dDom$dElement.text($0.label))));
};
const errorAlert = /* #__PURE__ */ mkAlert($$Error);
const domToSpecularNode = Unsafe$dCoerce.unsafeCoerce;
const runWidgetInDomNode = node => widget => {
  const $0 = Specular$dDom$dWidget.runWidgetInNode(node)(widget);
  return () => {
    const a$p = $0();
    return a$p._1;
  };
};
const controlButton = dynamicControlState => Specular$dFRP$dBase.bindDynamic.bind(dynamicControlState)(controlState => {
  const $0 = [
    Specular$dDom$dElement.class_("btn btn-primary"),
    Specular$dDom$dElement.attr("type")("submit"),
    controlState.tag === "Disabled" ? Specular$dDom$dElement.attr("disabled")("true") : Specular$dDom$dElement.monoidProp.mempty
  ];
  return (() => {
    const n = Specular$dInternal$dIncremental.constant($0);
    Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
    return n;
  })();
});
const alertIconSign = v => {
  if (v.tag === "Info") { return Specular$dDom$dElement.class_("icon-info-sign"); }
  if (v.tag === "Error") { return Specular$dDom$dElement.class_("icon-exclamation-sign"); }
  if (v.tag === "Success") { return Specular$dDom$dElement.class_("icon-ok-sign"); }
  if (v.tag === "Warning") { return Specular$dDom$dElement.class_("icon-warning-sign"); }
  $runtime.fail();
};
const alertClass = v => {
  if (v.tag === "Info") { return Specular$dDom$dElement.class_("alert alert-info"); }
  if (v.tag === "Error") { return Specular$dDom$dElement.class_("alert alert-danger"); }
  if (v.tag === "Success") { return Specular$dDom$dElement.class_("alert alert-success"); }
  if (v.tag === "Warning") { return Specular$dDom$dElement.class_("alert alert-warning"); }
  $runtime.fail();
};
const actionVisibleIfDyn = dynCond => inner => dynamicSwitch(Specular$dFRP$dBase.functorDynamic.map(v => {
  if (v) { return inner; }
  return Specular$dInternal$dRIO.pureImpl(Specular$dFRP$dBase.never);
})(dynCond));
export {
  $Alert,
  $AlertType,
  $ControlState,
  $DownloadButtonOptions,
  Alert,
  Disabled,
  DownloadButtonOptions,
  Enabled,
  $$Error as Error,
  Info,
  Success,
  Warning,
  actionVisibleIfDyn,
  alertClass,
  alertIconSign,
  controlButton,
  domToSpecularNode,
  dynamicSwitch,
  dynamic_,
  errorAlert,
  fileDownloadButton,
  infoAlert,
  itemToIndex,
  labeledForm,
  mkAlert,
  monadFRP,
  primaryButton,
  runWidgetInDomNode,
  specularToDomNode,
  successAlert,
  testId,
  testIdLegacyAdapterAttrs,
  testIdLegacyAdapterProp,
  toControlStateAttr,
  traverse_,
  visibleIfDyn,
  warningAlert,
  whitespace
};
